import React from "react";
import { motion } from "framer-motion";
import ContactInfoItem from "./ContactInfoItem";

const ContactSection = () => {
    return (
        <section className="flex flex-col items-center px-5 pt-60 w-full">
            <div className="w-full max-w-screen-xl">
                <div className="flex gap-6 justify-between max-md:flex-col max-md:items-center">
                    <ContactInfoItem icon="ti-email" title="Email Us">
                        <span>
                            For any inquiries or further information, feel free to reach out to
                            us via email at{" "}
                        </span>
                        <a
                            href="mailto:info@iexcel.my"
                            className="text-orange-500 no-underline"
                        >
                            info@iexcel.my
                        </a>
                        <span>. We aim to respond to all messages within 48 hours.</span>
                    </ContactInfoItem>

                    <ContactInfoItem icon="ti-headphone-alt" title="Call Us">
                        <span>You can contact us directly at </span>
                        <span className="font-bold">+6 (016) 293-2691</span>
                        <span>
                            . Our team is available to assist you from Monday to Friday, 9 AM to
                            5 PM.
                        </span>
                    </ContactInfoItem>

                    <ContactInfoItem icon="ti-location-pin" title="Visit Us">
                        <span>We welcome you to visit our office located at </span>
                        <span className="font-bold">
                            32-1, Jalan Temenggung 7/9, Bandar Mahkota Cheras, 43200 Cheras, Selangor, Malaysia
                        </span>
                        <span>. Please call ahead to schedule an appointment.</span>
                    </ContactInfoItem>
                </div>


            </div>

            {/* Google Map Embed */}
            <div className="mt-10 pt-5 w-screen">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3984.159398465205!2d101.788654!3d3.051963!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc3556d44582d5%3A0x69a9af9337a25e67!2siExcel%20International%20English!5e0!3m2!1sen!2sus!4v1745738115855!5m2!1sen!2sus"
                    width="100%"
                    height="450"
                    style={{ border: 0 }}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="iExcel International English Location"
                />
            </div>
        </section>

    );
};

export default ContactSection;
